import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export const StaffSectionHeader = ({ title, description, meta, action, sx }) => (
    <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        spacing={2}
        sx={{ mb: 2.5, ...sx }}
    >
        <Box sx={{ minWidth: 0 }}>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                    {title}
                </Typography>
                {meta}
            </Stack>
            {description && (
                <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
                    {description}
                </Typography>
            )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Stack>
);

export const StaffEmptyState = ({ icon: Icon, title, description, action, compact = false }) => (
    <Box
        sx={{
            px: 3,
            py: compact ? 3 : 5,
            textAlign: 'center',
            borderRadius: 3,
            border: '1px dashed #cbd5e1',
            bgcolor: '#f8fafc'
        }}
    >
        {Icon && (
            <Box sx={{ width: 44, height: 44, borderRadius: '50%', bgcolor: '#e8f5e9', color: 'primary.main', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', mb: 1.5 }}>
                <Icon sx={{ fontSize: 23 }} />
            </Box>
        )}
        <Typography variant="body2" sx={{ color: '#334155', fontWeight: 800 }}>
            {title}
        </Typography>
        {description && (
            <Typography variant="caption" sx={{ color: '#64748b', display: 'block', mt: 0.5, maxWidth: 520, mx: 'auto' }}>
                {description}
            </Typography>
        )}
        {action && <Box sx={{ mt: 2 }}>{action}</Box>}
    </Box>
);

